import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["manyOptions", "singleOption", "checkAi"];
  static values = {
    qtype: {
      type: String,
      default: "",
    }
  }

  connect() {
    this.#executeUpdate(this.qtypeValue);
  }

  updateType(e) {
    this.#executeUpdate(e.target.value);
  }

  #executeUpdate(val) {
    switch (val) {
      case "options_pick_many":
        this.#closeSingleOptions();
        this.#closeCheckAi();
        this.#openManyOptions();
        break;
      case "options_ai_check":
        this.#closeSingleOptions();
        this.#closeManyOptions();
        this.#openCheckAi();
        break;
      case "options_pick_one":
        this.#closeCheckAi();
        this.#closeManyOptions();
        this.#openSingleOptions();
        break;
      default:
        this.#closeCheckAi();
        this.#closeManyOptions();
        this.#closeSingleOptions();
    }
  }

  #closeCheckAi() {
    this.checkAiTarget.style.display = "none";
    const inputs = this.checkAiTarget.querySelectorAll("input");
    inputs.forEach(input => { input.disabled = true });
  }

  #openCheckAi() {
    console.log(this.checkAiTarget)

    this.checkAiTarget.style.display = "block";
    const inputs = this.checkAiTarget.querySelectorAll("input");
    inputs.forEach(input => { input.disabled = false });
  }

  #closeManyOptions() {
    this.manyOptionsTarget.style.display = "none";
    const inputs = this.manyOptionsTarget.querySelectorAll("input");
    inputs.forEach(input => { input.disabled = true });
  }

  #openManyOptions() {
    this.manyOptionsTarget.style.display = "block";
    const inputs = this.manyOptionsTarget.querySelectorAll("input");
    inputs.forEach(input => { input.disabled = false });
  }

  #closeSingleOptions() {
    this.singleOptionTarget.style.display = "none";
    const inputs = this.singleOptionTarget.querySelectorAll("input");
    inputs.forEach(input => { input.disabled = true });
  }

  #openSingleOptions() {
    this.singleOptionTarget.style.display = "block";
    const inputs = this.singleOptionTarget.querySelectorAll("input");
    inputs.forEach(input => { input.disabled = false });
  }
}
